import React from "react";
import settingIcon from "../../../assets/logos/SettingIcon.svg"; // <-- import your icon

const ActionButton = ({ label, onClick, btnImage, disabled }) => (
  <div className="">
    {/* <img src={settingIcon} alt="" className="btn-icon" /> */}
    <button type="button" className="action-btn" disabled={disabled} onClick={onClick}>
      <img src={btnImage} alt="" className="btn-icon" />
      {label}
    </button>
  </div>
);

export default ActionButton;
